import { createAction, props } from '@ngrx/store';
import { Country, Insurer, Language, ServiceAvailable } from '../../core/interfaces/doctor.interface';

// Languages
export const loadLanguages = createAction('[Referentiel] Load Languages');
export const loadLanguagesSuccess = createAction(
  '[Referentiel] Load Languages Success',
  props<{ languages: Language[] }>()
);
export const loadLanguagesFailure = createAction(
  '[Referentiel] Load Languages Failure',
  props<{ error: string }>()
);

// Services
export const loadServices = createAction('[Referentiel] Load Services');
export const loadServicesSuccess = createAction(
  '[Referentiel] Load Services Success',
  props<{ services: ServiceAvailable[] }>()
);
export const loadServicesFailure = createAction(
  '[Referentiel] Load Services Failure',
  props<{ error: string }>()
);

// Insurers
export const loadInsurers = createAction(
  '[Referentiel] Load Insurers',
  props<{ countryCode?: string }>() // Add countryCode param
);
export const loadInsurersSuccess = createAction(
  '[Referentiel] Load Insurers Success',
  props<{ insurers: Insurer[] }>()
);
export const loadInsurersFailure = createAction(
  '[Referentiel] Load Insurers Failure',
  props<{ error: string }>()
);

// Countries
export const loadCountries = createAction('[Referentiel] Load Countries');
export const loadCountriesSuccess = createAction(
  '[Referentiel] Load Countries Success',
  props<{ countries: Country[] }>()
);
export const loadCountriesFailure = createAction(
  '[Referentiel] Load Countries Failure',
  props<{ error: string }>()
);
